import type { Entity } from '@backstage/catalog-model';
import type { EntityFilter } from '@backstage/plugin-catalog-react';

import { normalizeEntityRef } from '@ipen-portal/plugin-common';

export class EntityDomainFilter implements EntityFilter {
  toQueryValue?: () => string | string[];

  constructor(
    readonly value: string | string[],
    readonly domainField = 'domain',
    readonly hideQueryParam = false,
  ) {
    this.toQueryValue = this.hideQueryParam ? undefined : () => this.value;
  }

  filterEntity(entity: Entity): boolean {
    const domain = entity.spec?.[this.domainField];
    if (typeof domain !== 'string') {
      return false;
    }
    const values = typeof this.value === 'string' ? [this.value] : this.value;
    const expectedRefs = values.map(name => normalizeEntityRef(name, 'Domain'));
    const currentRef = normalizeEntityRef(domain, 'Domain');
    return expectedRefs.includes(currentRef);
  }
}
